// extracted by mini-css-extract-plugin
module.exports = {"header":"StagingSectionEditorHeader_header_W3C0Q","spinAround":"StagingSectionEditorHeader_spinAround_oM_lt"};